import React from 'react';
import { ActivityRendererProps } from './types';
import ReadActivity from './ReadActivity';
import MCQActivity from './MCQActivity';
import QuizActivity from './QuizActivity';
import GameActivity from './GameActivity';
import WriteActivity from './WriteActivity';
import ReflectionActivity from './ReflectionActivity';
import CriticalThinkingActivity from './CriticalThinkingActivity';

const ActivityRenderer: React.FC<ActivityRendererProps> = ({ activity, onComplete }) => {
  switch (activity.type) {
    case 'read':
      return <ReadActivity activity={activity} onComplete={onComplete} />;
    case 'mcq':
      return <MCQActivity activity={activity} onComplete={onComplete} />;
    case 'quiz':
      return <QuizActivity activity={activity} onComplete={onComplete} />;
    case 'game':
      return <GameActivity activity={activity} onComplete={onComplete} />;
    case 'write':
      return <WriteActivity activity={activity} onComplete={onComplete} />;
    case 'reflection':
      return <ReflectionActivity activity={activity} onComplete={onComplete} />;
    case 'critical_thinking':
      return <CriticalThinkingActivity activity={activity} onComplete={onComplete} />;
    default:
      return (
        <div className="activity-placeholder">
          <p>Activity type "{activity.type}" not yet implemented.</p>
          <button className="complete-btn" onClick={() => onComplete()}>
            Mark as Complete
          </button>
        </div>
      );
  }
};

export default ActivityRenderer;

